/* eslint-disable import/no-named-as-default */
import React from 'react';
import { Tabs } from 'antd';
import { withRouter, Switch, Route } from 'react-router-dom';
import { ContainerStyled } from './styled';
import PriceListTable from '../PriceListTable';
import PriceEditPage from '../PriceEditPage';
import ProductGaragesPage from '../ProductGaragesPage';
import ProductEditForm from '../ProductEditForm';

const { TabPane } = Tabs;

function ProductEditTabs(props) {
  const { operation, catalogs, operationCatalogs, history, tabKey, isNew, onSave, onDelete } = props;
  return (
    <ContainerStyled className={isNew ? 'new-work-operation' : ''}>
      <Tabs
        type="card"
        defaultActiveKey={tabKey || 'details'}
        animated={false}
        tabBarGutter={15}
        onChange={(activeKey) => history.push(`/edit/${operation.sku}/${activeKey}`)}
      >
        <TabPane tab="Product Details" key="details">
          <ProductEditForm
            operation={operation}
            catalogs={catalogs}
            operationCatalogs={operationCatalogs}
            onSave={onSave}
            onDelete={onDelete}
          />
        </TabPane>

        <TabPane tab="Product Pricing" key="prices">
          <Switch>
            <Route
              path="/"
              component={() => <PriceListTable history={history} sku={operation.sku} parentOp={operation} />}
            />
            <Route path="/prices/:predefinedId" component={() => <PriceEditPage isNew={isNew} />} />
          </Switch>
        </TabPane>

        <TabPane tab="Garages" key="garages">
          <Switch>
            <Route
              path="/"
              component={() => (
                <ProductGaragesPage history={history} sku={operation.sku} parentOp={operation} />
              )}
            />
          </Switch>
        </TabPane>
      </Tabs>
    </ContainerStyled>
  );
}

export default withRouter(ProductEditTabs);
